<template>
  <div>
    <a
      v-if="slide && slide.url"
      :href="slide.url"
      target="_blank"
    >
      <div class="slide-home-image-light-mode d-none">
        <img :src="slide.image_desktop_url" class="w-100 image_desktop d-none d-md-inline-block" alt="Participe" />
        <img :src="slide.image_mobile_url" class="w-100 image_mobile d-inline-block d-md-none" alt="Participe" />
      </div>

      <div class="slide-home-image-night-mode d-none">
        <img :src="slide.image_desktop_night_url" class="w-100 image_desktop_night d-none d-md-inline-block" alt="Participe" />
        <img :src="slide.image_mobile_night_url" class="w-100 image_mobile_night d-inline-block d-md-none" alt="Participe" />
      </div>
    </a>
  </div>
</template>

<script>

import variables from '@/mixins/variables'

export default {
  name: 'SlideCard',
  props: ['slide'],
  mixins: [variables]
}
</script>

<style lang="scss">
body {
  &.night-mode {
    div.slide-home-image-night-mode{
      display: block!important;
    }
  }
  &:not(.night-mode){
    div.slide-home-image-light-mode{
      display: block!important;
    }
  }
}
</style>
